import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { LoadSpinner } from 'cstar-react-primitives/lib/redux-form/LoadSpinner';
import { List as IList } from 'immutable';

import NotFound from '../error/NotFound';
import ErrorBoundary from '../error/ErrorBoundary';

import AsyncFlowStep from './AsyncFlowStep';
import Redirect from './Redirect';
import { getBasePath } from './flow';
import { getStepConfigs, getHomePath } from './flowSelectors';



export const mapStepConfigToProps = (stepProps, stepConfig) => ({
    component: stepConfig.get('component'),
    flow: stepConfig.get('flow'),

    
    flowProps: stepConfig.get('flowProps', (_, ownProps) => ownProps),
    beforeRender: stepConfig.get('beforeRender', () => {}),
    isReady: stepConfig.get('isReady', () => true),
    canLoad: stepConfig.get('canLoad', () => ({ isAllowedOrPath: true })),
    canSkip: stepConfig.get('canSkip', () => false),
    onExit: stepConfig.get('onExit', () => {}),
    preConditions: stepConfig.get('preConditions', IList()),
    postConditions: stepConfig.get('postConditions', IList())
});


const mapStepConfigsToRoutes = steps => (
    steps.entrySeq().map(([path, stepConfig]) => (
        <Route
            key={path}
            path={`/${getBasePath()}/${path}`}
            render={renderProps => (
                <AsyncFlowStep
                    {...renderProps}
                    path={path}
                    {...mapStepConfigToProps(renderProps, stepConfig)}
                />
            )}
        />
    ))
);



export const flowFactory = reduxStore => () => {
    const currentStepConfigs = getStepConfigs(reduxStore);
    const homePath = `/${getBasePath()}/${getHomePath(reduxStore)}`;
    const homeRedirect = <Redirect pathname={homePath} />;

    const flow = mapStepConfigsToRoutes(currentStepConfigs);

    return (
        <ErrorBoundary>
            <Suspense fallback={<LoadSpinner />}>
                <Switch>
                    <Route key="home" exact path="/" render={() => homeRedirect} />
                    <Route key="store" exact path="/store" render={() => homeRedirect} />
                    {}
                    <Route key="legacy" path={['/store/buy', '/store/buy/*']} render={() => homeRedirect} />
                    {flow}
                    <Route component={NotFound} />
                </Switch>
            </Suspense>
        </ErrorBoundary>
    );
};
